export default __webpack_public_path__ + "static/lframe-inspiration-15413890e6815c5df257e458da19c754.png";